import React from 'react'
import { CreditCardFormState } from '~/types'
import { DraftResult } from 'vest/vestResult'
import styled from 'styled-components'
import TextInput from '~/components/atoms/TextInput'

interface Props {
  formState: CreditCardFormState
  handleChangeFactory(name: keyof CreditCardFormState): (value: any) => void
  result: DraftResult
}

export default function EditArea({ formState, handleChangeFactory, result }: Props) {
  return (
    <Container>
      <div>
        <TextInput
          placeholder='カード番号'
          onChange={handleChangeFactory('cardNumber')}
          value={formState.cardNumber}
          error={result.getErrors('cardNumber')}
        />
        <Note>Visa、Mastercard、JCB、Amex、Diners Club、Discoverが利用できます。</Note>
      </div>
      <TextInput
        placeholder='有効期限（月）'
        onChange={handleChangeFactory('expMonth')}
        type='number'
        value={`${formState.expMonth ?? ''}`}
        error={result.getErrors('expMonth')}
      />
      <TextInput
        placeholder='有効期限（年）'
        onChange={handleChangeFactory('expYear')}
        type='number'
        value={`${formState.expYear ?? ''}`}
        error={result.getErrors('expYear')}
      />
      <TextInput
        placeholder='セキュリティコード'
        onChange={handleChangeFactory('cvc')}
        value={formState.cvc}
        error={result.getErrors('cvc')}
      />
    </Container>
  )
}
const Container = styled.div`
  display: grid;
  grid-gap: 24px;
  margin-top: 48px;
  margin-bottom: 48px;
  text-align: left;
`
const Note = styled.div`
  text-align: left;
  margin-top: 8px;
  ${({ theme }) => theme.fonts.Bold14};
  color: ${({ theme }) => theme.colors.OnSurface5};
`
